export const EMAIL_VALIDATION = {
    required: 'Email обязателен',
    pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: 'Некорректный email',
    },
} as const

export const PASSWORD_VALIDATION = {
    required: 'Пароль обязателен',
} as const
